<template>
  <div class="popup-container" :class="{ active }">
    <div v-clickout.stop="() => (active ? popupResolve(undefined) : false)" class="content popup">
      <div class="close" @click.stop="() => (active ? popupResolve(undefined) : false)">
        <cross class="icon" />
      </div>
      <component :is="popupType" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateResumePopup from './CreateResumePopup';
import ShareResume from './ShareResume';
import DuplicateResume from './DuplicateResume';
import ConfirmPopup from './ConfirmPopup';
import TranslatePopup from '@/components/popup/TranslatePopup.vue';
import UpdateResumeLabels from './UpdateResumeLabels';
import cross from '../../assets/icons/cross.svg';
import CustomerServicePopup from './CustomerServicePopup.vue';
import ExportPopup from './ExportPopup.vue';

export default {
  name: 'PopupContainer',
  components: {
    CreateResumePopup,
    DuplicateResume,
    ShareResume,
    ConfirmPopup,
    UpdateResumeLabels,
    CustomerServicePopup,
    TranslatePopup,
    ExportPopup,
    cross,
  },
  props: {},
  data() {
    return {
      active: false,
    };
  },
  computed: {
    ...mapGetters(['user', 'popupType', 'popupResolve']),
  },
  watch: {
    popupType(newValue) {
      this.selectScroll(newValue);
    },
  },
  methods: {
    enableScroll() {
      document.querySelector('body').style.overflow = 'visible';
    },
    disableScroll() {
      document.querySelector('body').style.overflow = 'hidden';
    },
    selectScroll(value) {
      if (!value) this.enableScroll();
      else this.disableScroll();
      this.active = !!value;
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/responsive/popup.scss';

.popup-container {
  position: fixed;
  top: 50%;
  bottom: 50%;
  right: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 102;
  opacity: 0;

  .popup {
    width: 0;
    height: 0;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &.active {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(#0000, 0.3);
    opacity: 1;

    .close {
      position: absolute;
      right: 12px;
      top: 12px;
      width: 18px;
      height: 18px;
      transition: all 0.2s;
      display: flex;
      justify-content: center;
      align-items: center;

      .icon {
        width: 16px;
        height: 16px;
      }

      &:hover {
        cursor: pointer;
        background-color: #33333317;
        border-radius: 50%;
      }
    }

    .popup {
      position: relative;
      box-sizing: border-box;
      padding: 38px;
      width: auto;
      opacity: 1;
      min-height: 200px;
      height: auto;
      min-width: 480px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 32px rgba(50, 136, 206, 0.25);
      border: solid 1px rgba(129, 129, 129, 0);
    }
  }
}
</style>
